var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { style: _vm.s.container }, [
    _c("div", { style: _vm.s.wrapper }, [
      _c("div", { style: _vm.s.title }, [
        _vm._v(_vm._s(_vm.Title)),
        _c("span", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.ShowClose,
              expression: "ShowClose"
            }
          ],
          style: _vm.s.close,
          on: { click: _vm.close }
        })
      ]),
      _c("div", { staticClass: "head" }, [
        _c(
          "div",
          { staticClass: "__hint no_top" },
          [
            _c(
              "i18n",
              { attrs: { path: "tokenCard.charge.tips.0", tag: "span" } },
              [
                _c(
                  "span",
                  { staticClass: "strong", attrs: { place: "tokenSymbol" } },
                  [_vm._v(_vm._s(_vm.getTokenSymbol(_vm.token)))]
                )
              ]
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "__hint" },
          [
            _c(
              "i18n",
              { attrs: { path: "tokenCard.charge.tips.1", tag: "span" } },
              [
                _c(
                  "span",
                  { staticClass: "strong", attrs: { place: "tokenSymbol" } },
                  [_vm._v(_vm._s(_vm.getTokenSymbol(_vm.token)))]
                ),
                _c("span", { staticClass: "strong", attrs: { place: "min" } }, [
                  _vm._v(_vm._s(_vm.minimumDepositAmount))
                ])
              ]
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "__hint" },
          [
            _c(
              "i18n",
              { attrs: { path: "tokenCard.charge.tips.2", tag: "span" } },
              [
                _c(
                  "span",
                  {
                    staticClass: "strong",
                    attrs: { place: "confirmationCount" }
                  },
                  [_vm._v(_vm._s(_vm.confirmationCount))]
                )
              ]
            )
          ],
          1
        )
      ]),
      _c("div", { style: _vm.s.body }, [
        _c("div", { staticClass: "__row" }, [
          _c("span", { staticClass: "__row_t" }, [
            _vm._v(_vm._s(_vm.$t("tokenCard.charge.addressTitle")))
          ]),
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isLoading,
                expression: "!isLoading"
              }
            ],
            staticClass: "copy __pointer",
            attrs: { src: require("assets/imgs/copy_default.svg") },
            on: { click: _vm.copy }
          })
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isLoading,
                expression: "isLoading"
              }
            ],
            staticClass: "ex-center-loading"
          },
          [_c("loading", { attrs: { loadingType: "dot" } })],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isLoading,
                expression: "!isLoading"
              }
            ]
          },
          [
            _c("div", { staticClass: "__input_row __unuse_input top more" }, [
              _vm._v(_vm._s(_vm.addrErr || _vm.address))
            ]),
            _c(
              "div",
              { staticClass: "qrcode-container" },
              [
                _vm._v(
                  _vm._s(
                    _vm.$t("tokenCard.charge.codeTips", {
                      tokenSymbol: _vm.getTokenSymbol(_vm.token)
                    })
                  )
                ),
                _c("qrcode", {
                  staticClass: "qrcode-container__content",
                  attrs: { text: _vm.addressQrcode, options: _vm.qrOptions }
                })
              ],
              1
            ),
            _vm.showLabel
              ? _c("div", { staticClass: "__row" }, [
                  _c("span", { staticClass: "__row_t" }, [
                    _vm._v(_vm._s(_vm.labelName)),
                    _c("span", { staticClass: "red" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("tokenCard.charge.labelTips", {
                            labelName: _vm.labelName
                          })
                        )
                      )
                    ])
                  ]),
                  _c("img", {
                    staticClass: "copy __pointer",
                    attrs: { src: require("assets/imgs/copy_default.svg") },
                    on: { click: _vm.copyLabel }
                  })
                ])
              : _vm._e(),
            _vm.showLabel
              ? _c("div", { staticClass: "__input_row __unuse_input top" }, [
                  _vm._v(_vm._s(_vm.labelValue))
                ])
              : _vm._e(),
            _vm.showLabel
              ? _c(
                  "div",
                  { staticClass: "qrcode-container" },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("tokenCard.charge.labelCodeTips", {
                          labelName: _vm.labelName
                        })
                      )
                    ),
                    _c("qrcode", {
                      staticClass: "qrcode-container__content",
                      attrs: { text: _vm.labelValue, options: _vm.qrOptions }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]
        )
      ]),
      _vm.ShowBottom
        ? _c("div", { style: _vm.s.btnGroup }, [
            !!_vm.STxt
              ? _c(
                  "div",
                  {
                    style: [
                      _vm.s.btn,
                      _vm.BtnUnuse || _vm.btnUnuse ? _vm.s.unUse : undefined
                    ],
                    on: { click: _vm.rClick }
                  },
                  [_vm._v(_vm._s(_vm.STxt))]
                )
              : _vm._e(),
            !_vm.STxt
              ? _c(
                  "div",
                  { style: [_vm.s.lBtn, _vm.s.btn], on: { click: _vm.lClick } },
                  [_vm._v(_vm._s(_vm.LTxt))]
                )
              : _vm._e(),
            !_vm.STxt
              ? _c(
                  "div",
                  {
                    style: [
                      _vm.s.btn,
                      _vm.BtnUnuse || _vm.btnUnuse ? _vm.s.unUse : undefined
                    ],
                    on: { click: _vm.rClick }
                  },
                  [_vm._v(_vm._s(_vm.RTxt))]
                )
              : _vm._e()
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }